module.exports = __webpack_public_path__ + "img/co.612dec34.svg";